module.exports = __webpack_public_path__ + "media/categories/4099-798bc6d4.svg";